import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable()
export class DeviceInfoHelper {
  deviceInfo = null;
  constructor(private deviceService: DeviceDetectorService) {}

  getDeviceOS() {
    const deviceInfo = this.deviceService.getDeviceInfo();
    let os = '';
    const usrAgent = deviceInfo.userAgent;
    const texts = usrAgent.split(' ');
    texts.forEach((t, index) => {
      if (t === 'CPU') {
        os = texts[index + 1] + ' ' + texts[index + 2] + ' ' + texts[index + 3];
        return;
      }
      if (t === 'Android') {
        os = texts[index] + ' ' + texts[index + 1];
        return;
      }
    });
    return os;
  }
}
